import { render, staticRenderFns } from "./RegisterShare.vue?vue&type=template&id=21bdb306&scoped=true&"
import script from "./RegisterShare.vue?vue&type=script&lang=js&"
export * from "./RegisterShare.vue?vue&type=script&lang=js&"
import style0 from "./RegisterShare.vue?vue&type=style&index=0&id=21bdb306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bdb306",
  null
  
)

export default component.exports